import {Utilities} from '../../shared/utilities/utilities.model';
import {AttachedFile} from '../../shared/models/attached-file.model';
import {DateUtilities} from '../../shared/utilities/date-utilities.model';
/**
 * this class is used for => threads details and response to thread
 */
export class AlertModel {
	alert_id: string;
	created_at: string;
	created_by: string;
	user_id: string;
	readers: string[];
	module: string;
	thread_id: string;
	commodity_id: string;
	ald_commodity_id: string;
	ald_order_id: string;
	subject: string;
	text: string;
	attachments: Attachments[];
	is_read: boolean;

	constructor(model?: any) {
		this.attachments = [];
		this.readers = [];
		if (model) {
			this.alert_id = model.alert_id;
			this.created_at = model.created_at;
			this.created_by = model.created_by;
			this.user_id = model.user_id;
			if (!Utilities.isVoid(model.readers)) {
				for (let i = 0; i < model.readers.length; i++) {
					this.readers.push(model.readers[i]);
				}
			}
			this.module = model.module;
			this.thread_id = model.thread_id;
			this.commodity_id = model.commodity_id;
			this.ald_commodity_id = model.ald_commodity_id;
			this.ald_order_id = model.ald_order_id;
			this.subject = model.subject;
			this.text = model.text;
			if (!Utilities.isVoid(model.attachments)) {
				for (let i = 0; i < model.attachments.length; i++) {
					this.attachments.push(new Attachments(model.attachments[i]));
				}
			}
			this.is_read = model.is_read;
		}
	}

	public clone(): AlertModel {
		const clone = new AlertModel();
		clone.attachments = [];
		clone.readers = [];
		clone.alert_id = this.alert_id;
		clone.created_at = this.created_at;
		clone.created_by = this.created_by;
		clone.user_id = this.user_id;
		if (!Utilities.isVoid(this.readers)) {
			for (let i = 0; i < this.readers.length; i++) {
				clone.readers.push(this.readers[i]);
			}
		}
		clone.module = this.module;
		clone.thread_id = this.thread_id;
		clone.commodity_id = this.commodity_id;
		clone.ald_commodity_id = this.ald_commodity_id;
		clone.ald_order_id = this.ald_order_id;
		clone.subject = this.subject;
		clone.text = this.text;
		if (!Utilities.isVoid(this.attachments)) {
			for (let i = 0; i < this.attachments.length; i++) {
				clone.attachments.push(new Attachments(this.attachments[i]));
			}
		}
		clone.is_read = this.is_read;
		return clone;
	}

	addAttached(attached: AttachedFile): void {
		this.attachments.push({
			file_manager_id: attached.uuid,
			file_manager_name: attached.file_name,
			blob_name: attached.blob_name,
			blob_size: attached.file_size,
			mime_type: attached.mime_type,
			description: attached.description,
			created_at: DateUtilities.getUTCStringFromDate(new Date())
		});
	}
}

export class Attachments {
	file_manager_id: string;
	file_manager_name: string;
	blob_name: string;
	blob_size: number;
	mime_type: string;
	description: string;
	created_at: string;

	constructor(model?: any) {
		this.file_manager_id = model.file_manager_id;
		this.file_manager_name = model.file_manager_name;
		this.blob_name = model.blob_name;
		this.blob_size = model.blob_size;
		this.mime_type = model.mime_type;
		this.description = model.description;
		this.created_at = model.created_at;
	}

}

export class AlertsList {
	public alerts: AlertModel[];

	constructor(model?: any) {
		this.alerts = [];
		if (!Utilities.isVoid(model)) {
			model.forEach(alert => this.alerts.push(new AlertModel(alert)));
		}
	}
}


